import { Extension } from '@tiptap/core';

import {
  getInvisibleCharactersPlugin,
  INVISIBLE_CHARACTERS_PLUGIN_KEY,
  SET_INVISIBLE_CHARACTERS_VISIBLE_META,
} from '../plugins/getInvisibleCharactersPlugin';

export type TInvisibleCharactersOptions = {
  visible: boolean;
};

type TInvisibleCharactersStorage = {
  visibility: () => boolean;
};

declare module '@tiptap/core' {
  interface Storage {
    invisibleCharacters: TInvisibleCharactersStorage;
  }

  interface Commands<ReturnType> {
    invisibleCharacters: {
      toggleInvisibleCharacters: () => ReturnType;
    };
  }
}

// Local replacement for @tiptap/extension-invisible-characters: builds nothing until toggled on, unlike the vendor version which builds a widget per space even while hidden.
const InvisibleCharacters = Extension.create<TInvisibleCharactersOptions, TInvisibleCharactersStorage>({
  name: 'invisibleCharacters',

  addOptions() {
    return { visible: false };
  },

  addProseMirrorPlugins() {
    return [getInvisibleCharactersPlugin(this.options.visible)];
  },

  addStorage() {
    return { visibility: () => this.options.visible };
  },

  onBeforeCreate() {
    this.storage.visibility = () =>
      INVISIBLE_CHARACTERS_PLUGIN_KEY.getState(this.editor.state)?.visible ?? this.options.visible;
  },

  addCommands() {
    return {
      toggleInvisibleCharacters:
        () =>
        ({ dispatch, tr, state }) => {
          const visible = !INVISIBLE_CHARACTERS_PLUGIN_KEY.getState(state)?.visible;
          if (dispatch) tr.setMeta(SET_INVISIBLE_CHARACTERS_VISIBLE_META, visible);
          return true;
        },
    };
  },
});

export default InvisibleCharacters;
